import { ACTIONS_TOKEN } from '../actions/actionTypes';

const initialState = {
    tokenPortal: ""
};

export const reducersToken = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS_TOKEN:
            return {
                ...state,
                tokenPortal: action.tokenPortal
            };
        default:
            return state;
    }
};